import { dark } from './themes/dark';
import { light } from './themes/light';

export * from './util/resolveTheme';
export const theme = { light, dark };
